import { Lock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface AccessDeniedProps {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
}

export const AccessDenied = ({ 
  title = 'Acesso Negado',
  subtitle = 'Você não tem acesso a esta página. Entre em contato com o administrador.',
  icon
}: AccessDeniedProps) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white flex justify-center p-4">
      <Card className="w-full">
        <CardContent className="text-center p-12">
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-gray-100 p-3">
              {icon || <Lock className="w-8 h-8 text-black" />}
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            {title}
          </h2>
          <p className="text-lg text-gray-600 mb-6">
            {subtitle}
          </p>
          <Button 
            onClick={() => navigate(-1)}
            className="bg-black hover:bg-gray-800 text-white"
          >
            Voltar para página anterior
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
